import { Component } from 'react'
import RegMark from './ui/RegMark'
import { IconArrowRight } from './ui/Icon'
import { HOME_BY_LANG, langFromPath } from '../lib/routes'
import './error-boundary.css'

const FALLBACK_COPY = {
    tr: { title: 'Bir hata oluştu.', home: 'Ana sayfaya dön' },
    en: { title: 'Something went wrong.', home: 'Back to the home page' },
    de: { title: 'Es ist ein Fehler aufgetreten.', home: 'Zurück zur Startseite' },
}

/**
 * Last-resort fallback. It renders with no router dependency (a plain link and
 * a full reload), so it still works if it is ever mounted above the router.
 */
export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    componentDidCatch() {
        // Intentionally no logging: avoid leaking error context (no PII, no console).
    }

    render() {
        if (this.state.hasError) {
            const lang = langFromPath(window.location.pathname)
            const t = FALLBACK_COPY[lang]
            // data-error-boundary: prerender.js and scripts/verify-deploy.mjs fail a
            // route that renders this fallback, so a crash can never ship as a page.
            return (
                <div className="error-boundary-fallback" role="alert" lang={lang} data-error-boundary="">
                    <RegMark className="reg error-boundary-mark" size={40} />
                    <h1>{t.title}</h1>
                    <a href={HOME_BY_LANG[lang]} className="btn error-boundary-home">
                        {t.home}
                        <IconArrowRight />
                    </a>
                </div>
            )
        }

        return this.props.children
    }
}
